import { kMaxLength } from "buffer";
import { LegendItemProps } from "components/legendV2/LegendItem";
import { FilterProps } from "views/curatedViews/Filter";
import { InputLegendData, LegendData, WidgetControlsAction, WidgetControlsContextState } from "./types";

export const widgetControlsReducer = (
    state: WidgetControlsContextState,
    action: WidgetControlsAction
):WidgetControlsContextState => {
    switch (action.type) {
        case "disableAllKeys":
            return disableAllKeys(state);
        case "enableAllKeys":
            return enableAllKeys(state);
        case "toggleKey":
            return toggleKey(state,action.payload)
        case "hideLabels":
            return hideLabels(state);
        case "showLabels":
            return showLabels(state)
        case "toggleLabels":
            return toggleLabels(state);
        case "setLabelsToggleBtnStatus":
            return setLabelsToggleBtnStatus(state, action.payload);
        case "setLegend":
            return setLegend(state,action.payload);
        case "setFilterProps":
            return setFilterProps(state,action.payload)
        case "setLegendItemProps":
            return setLegendItemProps(state,action.payload)
    }
}

function hideLabels(state: WidgetControlsContextState): WidgetControlsContextState {
    return {...state,hideLabels:true}
}

function showLabels(state: WidgetControlsContextState): WidgetControlsContextState {
    return {...state,hideLabels:true}
}

function toggleLabels(state: WidgetControlsContextState): WidgetControlsContextState {
	return {...state, hideLabels: !state.hideLabels};
}

function setLabelsToggleBtnStatus(state: WidgetControlsContextState, status: boolean): WidgetControlsContextState {
		return {...state,enableLabelsToggle: status};
}

function setLegend(state: WidgetControlsContextState, payload: InputLegendData): WidgetControlsContextState {
    let keyValues = {}
    let allKeys = ""
    // init keyValues and check to make sure labels were sent
    payload.keys.forEach((k)=>{
        allKeys += k;
        keyValues[k]=true
    })
    // If all the keys are empty don't update
    if(allKeys==="") return state
    const newPayload:LegendData = {
        ...payload,
        keyValues:keyValues
    }
    return {...state,legend:newPayload}
}

function setFilterProps(state: WidgetControlsContextState, payload: FilterProps): WidgetControlsContextState {
    return {...state,filterOptions:payload}
}

/**
 * Get a reducer that modifies all keys to the setTo
 * value
 */
 const getKeySetter = (setTo:boolean) => (
    state: WidgetControlsContextState
): WidgetControlsContextState => {
    let keyValues = {}
    // init keyValues and check to make sure labels were sent
    state.legend.keys.forEach((k)=>{
        keyValues[k]=setTo
    })
    
    return {...state, legend:{...state.legend,keyValues:keyValues}}
}

const disableAllKeys = getKeySetter(false)
const enableAllKeys = getKeySetter(true)

function toggleKey(state: WidgetControlsContextState, payload: string): WidgetControlsContextState {
    let keyValues = {...state.legend.keyValues}
    keyValues[payload] = !keyValues[payload]
    return {...state, legend:{...state.legend,keyValues:keyValues}}
}

function setLegendItemProps(state: WidgetControlsContextState, payload: LegendItemProps[]): WidgetControlsContextState {
    return {...state, legend:{...state.legend,legendItemProps:payload}}
}

